<script setup>
import Button from '@components/global/forms/Button.vue'

const props = defineProps({
	project: {
		type: Object,
		required: true,
	},
})
</script>

<template>
	<div>
		<div class="flex aspect-4/3 flex-col border-2 border-crowns-off-white">
			<div class="flex h-8 justify-between gap-1 border-b-2 border-crowns-off-white bg-crowns-off-black p-1">
				<div class="flex gap-1">
					<div class="h-full w-5 flex-shrink-0 bg-[url('https://cdn.papercrowns.com/website/images/elements/accents/frame-accent-grip.svg')] bg-contain bg-center bg-repeat-x"></div>
					<div class="h-full w-5 flex-shrink-0 rounded-sm border border-crowns-off-white"></div>
				</div>
				<div class="line-clamp-1 font-cabazon text-lg leading-[1.2]">{{ project.name }}</div>
				<div class="h-full w-8 flex-shrink-0 bg-[url('https://cdn.papercrowns.com/website/images/elements/accents/frame-accent-grip.svg')] bg-contain bg-center bg-repeat-x"></div>
			</div>
			<div class="flex flex-grow bg-crowns-off-black">
				<div class="relative flex-grow">
					<img class="h-full w-full object-cover" :src="project.poster" :alt="`${project.name} Poster`" />
					<Button class="absolute bottom-5 left-5" label="View Project" :to="{ name: 'project', params: { slug: project.slug } }" />
				</div>
				<div class="h-full w-5 flex-shrink-0 border-l-2 border-crowns-off-white bg-crowns-off-black bg-[url('https://cdn.papercrowns.com/website/images/elements/accents/frame-accent-scroll.svg')] bg-[length:100%_auto] bg-repeat"></div>
			</div>
		</div>
		<div class="absolute -bottom-4 -left-3 -z-10 h-full w-full bg-crowns-off-black/25" />
	</div>
</template>
